import { Lockup } from '@/components/brand/Brand'
import { communityCopy, fillCopy, formatNominationNumber } from '@/nominations/communityCopy'
import type { NominationConfig } from '@/nominations/types'
import { sitePages } from '@/config/pages'

type NominationFooterProps = {
  nomination: NominationConfig
}

export const NominationFooter = ({ nomination }: NominationFooterProps) => (
  <footer className="footer wrap nom-footer">
    <p className="footer-brand">
      <Lockup />
      <span className="sr-only">{communityCopy.footerBrand}</span>
    </p>
    <div className="nom-footer-meta">
      <p className="nom-footer-note">
        {fillCopy(communityCopy.footerNote, { nomineeName: nomination.nominee.fullName })}{' '}
        <span className="nom-number">{formatNominationNumber(nomination.number)}</span>
      </p>
      {/* A plain link: nomination pages do not depend on the site's router. */}
      <a className="nom-footer-link" href={sitePages.privacy.path}>
        Privacy policy
      </a>
    </div>
  </footer>
)
